import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSClassificacaoFiscalService from '@/services/SistemaDKP/SLSClassificacaoFiscal.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useUsersList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSClassificacaoFiscalService = new SLSClassificacaoFiscalService();
  const refClassificacaoFiscalListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'classificacao_fiscal_id', label: 'Codigo', sortable: false },
    { key: 'classificacao_fiscal_descricao', label: 'Descrição', sortable: true },
    { key: 'classificacao_fiscal_ncm', label: 'NCM', sortable: true },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(10);
  const totalClassificacaoFiscal = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('classificacao_fiscal_id');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refClassificacaoFiscalListTable.value ? refClassificacaoFiscalListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalClassificacaoFiscal.value,
    };
  });

  const refetchData = () => {
    refClassificacaoFiscalListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchClassificacaoFiscal = (ctx, callback) => {
    overlay.value = true;
    sLSClassificacaoFiscalService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      // console.log(data);
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalClassificacaoFiscal.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const createOrUpdated = async (body) => {
    if (body.classificacao_fiscal_id) {
      await sLSClassificacaoFiscalService.update(body.classificacao_fiscal_id, body);
    } else {
      await sLSClassificacaoFiscalService.store(body);
    }
    refetchData();
  };

  const removerData = async (id) => {
    await sLSClassificacaoFiscalService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchClassificacaoFiscal,
    tableColumns,
    perPage,
    currentPage,
    totalClassificacaoFiscal,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refClassificacaoFiscalListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    createOrUpdated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
